var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DicCascader"},[_c('el-cascader',{attrs:{"options":_vm.options,"props":_vm.optionProps,"clearable":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }